import {useState} from "react";

import Text from "@/base/Text";
import Header from "@/base/Header";
import Form from "@/base/Form";
import FormInput from "@/base/FormInput";
import FieldError from "@/base/FieldError";

import {useTheme, css} from "@emotion/react";
import { US_STATES } from "@util/constants.js";

const BecomeDealerForm = () => {
    const theme = useTheme();

    const smWrap = css(`
        max-width: 39.8rem;
        margin-left: auto;
        margin-right: auto;
    `);

    const [formData, setFormData] = useState({})
    const [formIsComplete, setFormIsComplete] = useState(false);

    const subBoxCss = {
        background: "#f4f4f4", //theme.colors.text.secondary[theme.variant],
        border: `0.2rem solid ${theme.colors.background.secondary[theme.variant]}`,
        padding: "1.6rem 2.4rem 1.8rem",
        marginBottom: "2.4rem",

        "> div": {
            marginBottom: "0",

            "> input": {
                backgroundColor: "#ffffff",
            }
        },
    };

    const showFedId = () => {
        return {display: formData && formData.resellers_license && formData.resellers_license === 'true' ? 'block' : 'none'}
    }

    const showFeatureOptions = () => {
        return {display: formData && formData.showroom && formData.showroom === 'true' ? 'block' : 'none'}
    }

    const showResidentialCount = () => {
        return {display: formData && formData.project_types && formData.project_types.indexOf('residential') > -1 ? 'block' : 'none'}
    }

    const showCommercialCount = () => {
        return {display: formData && formData.project_types && formData.project_types.indexOf('commercial') > -1 ? 'block' : 'none'}
    }

    const showInHouse = () => {
        return {display: formData && formData.installation_services && formData.installation_services === 'true' ? 'block' : 'none'}
    }


    if (formIsComplete) {
        return (
            <div>
                <Header tag="h3">Thank You</Header>
                <Text>We have received your submission.</Text>
            </div>
        );
    }

    return (
        <Form name="lac_become_dealer" onChange={setFormData} onSuccess={() => setFormIsComplete(true)}>

            <FormInput
                type="text"
                label="First Name"
                required={true}
                name="first_name"
                builtinError={true}
            />

            <FormInput
                type="text"
                label="Last Name"
                required={true}
                name="last_name"
                builtinError={true}
            />

            <FormInput
                type="email"
                label="Email Address"
                required={true}
                name="email"
                builtinError={true}
            />

            <FormInput
                type="text"
                label="Company Name"
                required={true}
                name="company_name"
                builtinError={true}
            />

            <FormInput
                type="text"
                label="Address"
                required={true}
                name="address"
                builtinError={true}
            />

            <div css={{ display: "flex" }}>

              <span css={{ width: "60%", flexGrow: 1, marginRight: "0.25em" }}>
                <FormInput
                    type="text"
                    label="City"
                    required={true}
                    name="city"
                    builtinError={true}
                />
              </span>

                <span css={{ flexGrow: 1 }}>

                    <FormInput
                        type="select"
                        label="State"
                        required={true}
                        name="state"
                        builtinError={true}
                    >
                      {US_STATES.map((state) => (
                          <option key={state.abbrev} value={state.abbrev}>
                              {state.abbrev}
                          </option>
                      ))}
                    </FormInput>
              </span>

            </div>

            <FormInput
                type="text"
                label="Zip Code"
                required={true}
                name="zip"
                builtinError={true}
            />

            <FormInput
                type="phone"
                label="Phone Number"
                required={true}
                name="phone"
                placeholder="(xxx) xxx - xxxx"
                builtinError={true}
            />

            <FormInput type="phone" label="Fax" name="fax" />
            <FormInput type="text" label="Website URL" name="website_url" />
            <FormInput type="text" label="Owner" name="owner" />
            <FormInput type="text" label="Sales Manager" name="sales_manager" />
            <FormInput type="text" label="Parent Company" name="parent_company"/>
            <FormInput type="text" label="Company Type" name="company_type" />

            <div className="pt-2" css={smWrap}>
                <Header tag="h4" tagStyle="h5">
                    Would you like to apply for credit terms?&nbsp;*
                </Header>
                <div className="row">
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="Yes"
                            name="credit_terms"
                            value="true"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="No"
                            name="credit_terms"
                            value="false"
                        />
                    </div>
                </div>
                <FieldError name={`credit_terms`}/>
            </div>

            <div className="pt-2" css={smWrap}>
                <Header tag="h4" tagStyle="h5">
                    Would you have a reseller&apos;s license?&nbsp;*
                </Header>
                <div className="row">
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="Yes"
                            name="resellers_license"
                            value="true"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="No"
                            name="resellers_license"
                            value="false"
                        />
                    </div>
                </div>
                <FieldError name={`resellers_license`}/>

                <div style={showFedId()} css={subBoxCss}>

                    <FormInput
                        type="text"
                        label="Federal ID#"
                        required={true}
                        name="federal_id"
                        builtinError={true}
                    />
                </div>
            </div>


            <FormInput
                type="text"
                label="Number of store locations"
                required={true}
                name="store_count"
                builtinError={true}
            />

            <FormInput
                type="text"
                label="Number of employees"
                required={true}
                name="employee_count"
                builtinError={true}
            />

            <FormInput
                type="number"
                label="Number of years in business"
                required={true}
                name="years_in_business"
                builtinError={true}
            />

            <FormInput
                type="text"
                label="Number of outside sales representatives"
                required={true}
                name="external_sales_rep_count"
                builtinError={true}
            />

            <FormInput
                type="text"
                label="Number of inside sales representatives"
                required={true}
                name="internal_sales_rep_count"
                builtinError={true}
            />

            <div className="pt-2" css={smWrap}>
                <Header tag="h4" tagStyle="h5">Annual Sales Volume&nbsp;*</Header>
                <FieldError name={`annual_sales_volume`}/>
                <div className="row">
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="100k-1M"
                            name="annual_sales_volume"
                            value="100"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="1M - 5M"
                            name="annual_sales_volume"
                            value="1000"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="5M - 10M"
                            name="annual_sales_volume"
                            value="5000"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="10M - 20M"
                            name="annual_sales_volume"
                            value="10000"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label=">20M"
                            name="annual_sales_volume"
                            value="20000"
                        />
                    </div>
                </div>
            </div>

            <div className="pt-2" css={smWrap}>
                <Header tag="h4" tagStyle="h5">
                    Annual expected sales with LaCantina Doors&nbsp;*
                </Header>
                <FieldError name={`annual_expected_lacantina`}/>
                <div className="row">
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="10k-25k"
                            name="annual_expected_lacantina"
                            value="$10,000+"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="25k - 50k"
                            name="annual_expected_lacantina"
                            value="$25,000+"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="50k - 100k"
                            name="annual_expected_lacantina"
                            value="$50,000+"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="100k - 200k"
                            name="annual_expected_lacantina"
                            value="$100,000+"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="200k - 300k"
                            name="annual_expected_lacantina"
                            value="$200,000+"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="300k - 500k"
                            name="annual_expected_lacantina"
                            value="$300,000+"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="500k - 1,000k"
                            name="annual_expected_lacantina"
                            value="$500,000+"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label=">1,000k"
                            name="annual_expected_lacantina"
                            value="$1,000,000+"
                        />
                    </div>
                </div>
            </div>


            <FormInput
                type="textarea"
                label="What brands do you carry/sell?"
                name="other_brands"
                required={true}
                builtinError={true}
            />

            <div className="pt-2" css={smWrap}>
                <Header tag="h4" tagStyle="h5">Do you have a showroom?&nbsp;*</Header>
                <FieldError name={`showroom`}/>

                <div className="row">
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="Yes"
                            name="showroom"
                            value="true"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="No"
                            name="showroom"
                            value="false"
                        />
                    </div>
                </div>
            </div>

            <div className="pt-2" style={showFeatureOptions()} css={subBoxCss}>
                <Header tag="h4" tagStyle="h5">
                    Does your showroom feature a folding or multi-slide door?&nbsp;*
                </Header>
                <FieldError name={`folding_multislide`}/>
                <div css={{backgroundColor: "#ffffff", padding: "1.4rem 1.4rem 0.1rem"}}>
                    <FormInput
                        type="radio"
                        label="Yes, a folding door"
                        name="folding_multislide"
                        value="folding"
                    />
                    <FormInput
                        type="radio"
                        label="Yes, a multi-slide door"
                        name="folding_multislide"
                        value="multi"
                    />
                    <FormInput
                        type="radio"
                        label="Yes, folding and multi-slide doors"
                        name="folding_multislide"
                        value="both"
                    />
                    <FormInput
                        type="radio"
                        label="No"
                        name="folding_multislide"
                        value="none"
                    />
                </div>

            </div>

            <div className="pt-2" css={smWrap}>
                <Header tag="h4" tagStyle="h5">
                    Are you interested in our display program?&nbsp;*
                </Header>
                <div className="row">
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="Yes"
                            name="display_program_interest"
                            value="true"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="No"
                            name="display_program_interest"
                            value="false"
                        />
                    </div>
                </div>
            </div>

            <div className="pt-2" css={smWrap}>
                <Header tag="h4" tagStyle="h5">Which type of projects do you deal with?&nbsp;*</Header>
                <FieldError name={`project_types`}/>
                <FormInput
                    type="checkbox"
                    label="Residential"
                    name="project_types"
                    value="residential"
                />

                <div style={showResidentialCount()}>
                    <FormInput
                        type="text"
                        label="How many?"
                        name="residential_count"
                    />
                </div>

                <FormInput
                    type="checkbox"
                    label="Commercial"
                    name="project_types"
                    value="commercial"
                />

                <div style={showCommercialCount()}>
                    <FormInput
                        type="text"
                        label="How many?"
                        name="commercial_count"
                    />
                </div>


            </div>

            <div className="pt-2" css={smWrap}>
                <Header tag="h4" tagStyle="h5">Do you offer installation services?&nbsp;*</Header>
                <FieldError name={`installation_services`}/>
                <div className="row">
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="Yes"
                            name="installation_services"
                            value="true"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="No"
                            name="installation_services"
                            value="false"
                        />
                    </div>
                </div>
            </div>


            <div style={showInHouse()} css={subBoxCss}>
                <Header tag="h4" tagStyle="h5">
                    Is the service in-house or independent?&nbsp;*
                </Header>
                <FieldError name={`in_house_independent`}/>
                <div css={{backgroundColor: "#ffffff", padding: "1.4rem 1.4rem 0.1rem"}}>
                    <FormInput
                        type="radio"
                        label="In house"
                        name="in_house_independent"
                        value="inhouse"


                    />
                    <FormInput
                        type="radio"
                        label="Independent"
                        name="in_house_independent"
                        value="independent"


                    />
                </div>
            </div>


            <div className="pt-2 mb-3" css={smWrap}>
                <Header tag="h4" tagStyle="h5">Do you have service technicians?&nbsp;*</Header>
                <FieldError name={`service_technicians`}/>
                <div className="row">
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="Yes"
                            name="service_technicians"
                            value="true"
                        />
                    </div>
                    <div className="size-full size-xs-1of2">
                        <FormInput
                            type="radio"
                            label="No"
                            name="service_technicians"
                            value="false"
                        />
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default BecomeDealerForm;
